import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative flex w-full',
    wrapper: 'h-[100%] pt-[32px] pb-[48px]',
    container:
      'container flex gap-[30px] lg:gap-[96px] has-[.level-1]:[&>a]:hidden',
    categories:
      'shadow-scroll flex flex-nowrap items-center gap-[15px] overflow-x-auto overflow-y-hidden 2xl:gap-[35px] 2xl:overflow-x-hidden',
    item: 'group hover:[&>div]:text-brand-300 hover:[&:not(.child)>div]:after:bg-brand-300 xl:flex-shrink-unset flex flex-shrink-0 items-center gap-[2px] whitespace-nowrap select-none hover:[&:not(.child)>div]:relative hover:[&:not(.child)>div]:after:absolute hover:[&:not(.child)>div]:after:top-[39px] hover:[&:not(.child)>div]:after:h-[1px] hover:[&:not(.child)>div]:after:w-full hover:[&:not(.child)>div]:after:content-[""]',
    itemLabel:
      'text-regular w-full text-sm leading-[140%] [&>span]:max-w-[190px] [&>span]:whitespace-normal',
    group: 'group bg-bg-page -mx-10 mt-5 -mb-6 px-10 py-6',
    children: '',
    subchildren:
      'bg-system-gray-900 h-[100%] [&>div]:border-0 [&>div]:pt-0! [&>div>div]:justify-start',
    itemGrouped:
      '[&:last-child>a:last-child>div]:text-brand-400 flex w-full max-w-[186px] flex-col gap-[16px] has-[.level-1]:relative [&:last-child>a:last-child>div]:font-semibold',
    itemBanner: 'relative h-fit',
    itemBannerText:
      'absolute bottom-[32px] left-[32px] text-2xl leading-[120%] font-extrabold tracking-[2%] text-white',
    chevronIcon:
      'group-hover:text-brand-400 inline size-[16px] rotate-270 [&>path]:stroke-white'
  },
  variants: {
    color: {
      light: {
        itemLabel: '[&>span]:text-text-main hover:[&>span]:text-brand-300'
      },
      dark: {
        itemLabel:
          'hover:[&>span]:text-brand-300 [&>span.text-brand-400]:text-brand-400 [&>span]:text-white'
      },
      base: {
        itemLabel:
          'hover:[&>span]:text-brand-300 [&>span.text-brand-400]:text-brand-400 [&>span]:text-white'
      }
    },
    link: {
      true: {
        item: 'cursor-pointer'
      }
    },
    itemActive: {
      true: {
        item: '[&>div]:text-brand-300 [&:not(.child)>div]:after:bg-brand-300 [&:not(.child)>div]:relative [&:not(.child)>div]:after:absolute [&:not(.child)>div]:after:top-[39px] [&:not(.child)>div]:after:h-[1px] [&:not(.child)>div]:after:w-full [&:not(.child)>div]:after:content-[""]',
        itemLabel: 'text-brand-300'
      }
    },
    itemGroup: {
      true: {
        item: ''
      }
    }
  },
  compoundVariants: [
    {
      itemGroup: true,
      itemActive: true,
      className: {
        item: 'bg-white'
      }
    }
  ]
});
